
import { Bar, BarChart, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

export interface TimeseriesData {
  date: string;
  views: number;
  clicks: number;
}

interface TimeseriesChartProps {
  timeseriesData: TimeseriesData[];
}

const TimeseriesChart = ({ timeseriesData }: TimeseriesChartProps) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>7-Day Trend</CardTitle>
        <CardDescription>Page views and button clicks over time</CardDescription>
      </CardHeader>
      <CardContent>
        <div style={{ width: '100%', height: 300 }}>
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={timeseriesData}>
              <XAxis dataKey="date" />
              <YAxis />
              <Tooltip />
              <Legend />
              <Bar dataKey="views" name="Page Views" fill="#8884d8" />
              <Bar dataKey="clicks" name="Button Clicks" fill="#82ca9d" />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </CardContent>
    </Card>
  );
};

export default TimeseriesChart;
